// extracted by mini-css-extract-plugin
export default {"container":"MessagesSeparator_container__pOD-s"};